import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map, shareReplay, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private isInit:boolean = false;
  private selectedCustomerSubject = new BehaviorSubject<{ customerCode: string, customerName: string, country:string, completeDelivery:boolean, salesOffice: string } | null>(this.loadFromStorage());
  selectedCustomer$ = this.selectedCustomerSubject.asObservable();
  private validation$: Observable<void> | null = null;
  private validatedKey: string | null = null;

  constructor(private http: HttpClient) {
  }

  init() {
    if(this.isInit) return
      const path = window.location.pathname;

      if (path.includes('/iam') || path.includes('/oes')) {
        this.loadMoreCustomers(1, 20, '').subscribe((items: any) => {
          this.isInit = true;
          this.selectFirstCustomerIfNone(
            items?.data?.customerRelationVOList?.records
          );
        });
      }
  }
  setSelectedCustomer(customer: any) {
    customer.country = localStorage.getItem('country');
    localStorage.setItem("customer", JSON.stringify(customer));
    this.selectedCustomerSubject.next(customer);
  }

  getSelectedCustomer() {
    return this.selectedCustomerSubject.getValue();
  }

  private loadFromStorage(): { customerCode: string, customerName: string, country:string ,completeDelivery:boolean, salesOffice: string} | null {
    const storedCustomer = localStorage.getItem("customer");
    return storedCustomer ? JSON.parse(storedCustomer) : null;
  }

  getCustomerByOrg(params:any){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/masterData/customer/relation', params, { headers });
  }
  
  loadMoreCustomers(page: number, pageSize: number, customerKeyword: string): Observable<any> {
    const params = {
      pageNum: page,
      pageSize: pageSize,
      customerKeyword: customerKeyword
    };
    return  this.getCustomerByOrg(params);
  }

  // Stored CUSTOMER-CODE may be unbound already; backend rejects relation calls carrying it
  private fetchAllRelationsWithoutCustomer(): Observable<any> {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true').set('skipCustomerCode', 'true');
    return this.http.post<any>('/masterData/customer/relation', { pageNum: 1, pageSize: -1, customerKeyword: '' }, { headers });
  }

  /**
   * Verifies (once per token + country) that the stored customer is still bound to the user;
   * otherwise falls back to the first customer returned by masterData/customer/relation.
   */
  ensureValidCustomer(): Observable<void> {
    const token = localStorage.getItem('token');
    const path = window.location.pathname;
    if (!token || !(path.includes('/iam') || path.includes('/oes'))) {
      return of(undefined);
    }
    const key = `${token}|${localStorage.getItem('country')}`;
    if (this.validatedKey === key) {
      return of(undefined);
    }
    if (!this.validation$) {
      this.validation$ = this.fetchAllRelationsWithoutCustomer().pipe(
        tap(res => {
          if (!res?.data?.customerRelationVOList) return;
          const records: any[] = res.data.customerRelationVOList.records || [];
          const stored = this.getSelectedCustomer();
          const country = localStorage.getItem('country');
          const storedStillBound = !!stored && stored.country === country
            && records.some(item => item.customerCode === stored.customerCode);
          if (storedStillBound) return;
          if (records.length > 0) {
            this.setSelectedCustomer({ ...records[0] });
          } else {
            localStorage.removeItem('customer');
            this.selectedCustomerSubject.next(null);
          }
        }),
        tap(() => this.validatedKey = key),
        map(() => undefined),
        // Don't block other requests if the check itself fails
        catchError(() => of(undefined)),
        finalize(() => this.validation$ = null),
        shareReplay(1)
      );
    }
    return this.validation$;
  }

  selectFirstCustomerIfNone(items:any): void {
    const selectedCustomer = this.getSelectedCustomer();
    const country = localStorage.getItem('country');

    if (selectedCustomer && selectedCustomer.country === country) {
    } else if (items?.length > 0) {
      // If selectedCustomer does not exist and items list is not empty
      const firstCustomer = items[0];
      // this.setSelectedCustomer({customerCode: firstCustomer.customerCode, customerName: firstCustomer.customerName});
      this.setSelectedCustomer({ ...firstCustomer });
    } else {
       // If the items list is empty, reset selectedCustomerName and selectedCustomerCode to null
      localStorage.removeItem('customer');
      this.selectedCustomerSubject.next(null);
    }
  }
}
